export default __webpack_public_path__ + "static/media/lep1.155ef0fc.png";